import React, { useState, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { Typography, Grid, Chip } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { emailPdf } from '../../features/datacenter/historySlice';

const GetPdfForm = ({ getPdfFormOpen, handleGetPdfFormClose, reportIDs, mapOption = true }) => {
    const dispatch = useDispatch();
    const [mapNeeded, setMapNeeded] = useState(mapOption);
    const [currentEmail, setCurrentEmail] = useState('')
    const [emails, setEmails] = useState([]);

    const addEmails = () => {
        if (emails.indexOf(currentEmail) === -1) {
            setEmails([...emails, currentEmail]);
            setCurrentEmail('');
        }
    }
    const emailDelete = (email) => {
        const index = emails.indexOf(email);
        if (index !== -1) {
            let newe = [...emails];
            newe.splice(index, 1);
            setEmails(newe);
        }
    }


    const validateEmail = (email) => {
        //const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    const submitForm = () => {
        reportIDs.forEach(reportID => dispatch(emailPdf({ reportID, emails, mapNeeded })));
        handleGetPdfFormClose();
    }

    return (
        <Dialog open={getPdfFormOpen} onClose={handleGetPdfFormClose}>
            <DialogTitle><b>Email PDF Report</b></DialogTitle>
            <DialogContent>
                {
                    mapOption &&
                    <Fragment>
                        <Typography variant="body1"><b style={{ color: 'DodgerBlue' }}>Route Map</b></Typography>
                        <DialogContentText>
                            <Switch
                                checked={mapNeeded}
                                onChange={() => setMapNeeded(!mapNeeded)}
                                name="Map Needed"
                                inputProps={{ 'aria-label': 'Google Map Route' }}
                            />
                            Vehicle's movement path on Google map will{!mapNeeded && ' not'} be included in the report.
                        </DialogContentText>

                        <br />
                    </Fragment>
                }

                <Typography variant="body1"><b style={{ color: 'DodgerBlue' }}>Email Address</b></Typography>
                <DialogContentText>
                    Please add third party email addresses for directly sending the report. You can add multiple email addresses here.
                </DialogContentText>
                <Grid container spacing={2}>
                    <Grid item>
                        <TextField
                            autoFocus
                            id="name"
                            label="Add Email Address"
                            type="email"
                            value={currentEmail}
                            onChange={(e) => setCurrentEmail(e.target.value)}
                            variant="filled"
                        />

                    </Grid>
                    <Grid item style={{ display: "flex" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={addEmails} disabled={!validateEmail(currentEmail)}>
                            <AddCircleOutlineIcon fontSize="large" />
                        </Button>
                    </Grid>
                    <Grid item sm={12}>
                        {
                            emails.map(e =>
                                <Chip
                                    size="small"
                                    label={e}
                                    onDelete={() => emailDelete(e)}
                                    key={e}
                                    color="primary"
                                    variant="outlined"
                                    style={{ margin: '5px' }}
                                />
                            )
                        }
                    </Grid>

                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleGetPdfFormClose} color="secondary" variant="contained">
                    Cancel
                </Button>
                <Button onClick={() => submitForm()} color="primary" disabled={emails.length === 0} variant="contained">
                    Send Email
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default GetPdfForm;